export interface IRenderOptionByTypeProps {
  blockValue: Element;
  dataType: number;
  changeValue: (value: any) => void;
  value?: string;
}

export enum EPeriodTypes {
  "DATE",
  "DATE_RANGE",
  "WEEK_AND_DAY",
  // "CAL_REF", не реализован
}